export interface Debts {
    sqPassagemAvulsa: number;
    dataPassagem: Date;
    idPassagemFreeFlow: number;
    valorPassagem: number;
    vlMulta: number;
    nmPraca: string;
    nmConcessionaria: string;
}

interface FormattedDebts {
    id: string;
    date: string;
    hour: string;
    price: string;
    original: Debts;
    owner: string;
}

export const getFormattedDebts = (debts: Debts[]) => {
    if (!debts) return { totalDebts: 0, groupedDebts: [] };

    const formatDebt = (item: Debts) => {
        const date = item?.dataPassagem ? new Date(item?.dataPassagem) : null;
        const formattedDate = date?.toLocaleDateString('pt-BR');
        const formattedHour = date?.toLocaleTimeString('pt-BR', { hour12: false });
        const price = (item?.valorPassagem + item?.vlMulta)
            .toFixed(2)
            .replace('.', ',');

        return {
            id: item?.sqPassagemAvulsa?.toString(),
            date: formattedDate ?? "",
            hour: formattedHour ?? "",
            price,
            original: item,
            owner: item?.nmConcessionaria,
        };
    };

    const groupedDebts = debts
        .map(formatDebt)
        .reduce<Record<string, FormattedDebts[]>>((acc, debt) => {
            const { owner } = debt;
            if (!acc[owner]) {
                acc[owner] = [];
            }
            acc[owner].push(debt);
            return acc;
        }, {});

    const result = Object.entries(groupedDebts).map(([owner, debts]) => ({
        owner,
        total: debts.reduce((sum, item) => sum + parseFloat(item.price.replace(',', '.')), 0),
        debts,
    }));

    const totalDebts = debts.length;

    return { totalDebts, groupedDebts: result };
};

export interface Tickets {
    sqPagamento: number;
    dataPagamento: Date;
    valorPassagem: number;
    status: string;
}

interface FormattedTickets {
    id: string;
    date: string;
    price: string;
    status: string;
}

export const getFormattedTickets = (tickets: Tickets[]) => {
    if (!tickets) return [];

    const formattedTickets: FormattedTickets[] = tickets?.
        filter(item => item?.status?.toLocaleLowerCase()?.includes("processamento"))?.
        map(item => {
        const date = item?.dataPagamento ? new Date(item?.dataPagamento) : null;
        const formattedDate = date?.toLocaleDateString('pt-BR');
        return {
            id: String(item?.sqPagamento ?? 0),
            date: formattedDate ?? "",
            price: item?.valorPassagem?.toFixed(2)?.replace(/\./g, ','),
            status: item.status,
        }
    });

    return formattedTickets;
};

export interface DebtsByInvoice {
    sqPagamento: number;
    valorPassagem: number;
    dataTransacao: Date;
    nmConcessionaria: string;
    placa: string;
}

interface FormattedDebtsByInvoice {
    plate: string;
    date: string;
    price: string;
    owner: string;
}

export const getFormattedDebtsByInvoice = (debts: DebtsByInvoice[]) => {
    if (!debts) return [];

    const formattedTickets: FormattedDebtsByInvoice[] = debts?.map(item => {
        const date = new Date(item?.dataTransacao);
        const formattedDate = date.toLocaleDateString('pt-BR');
        return {
            id: String(item?.sqPagamento ?? 0),
            date: formattedDate,
            price: item?.valorPassagem?.toFixed(2)?.replace(/\./g, ','),
            plate: item.placa,
            owner: item.nmConcessionaria,
        }
    });

    return formattedTickets;
};